

<template>
  <div class="multimedia-record" :data-src="record.url || record.serverId">
    <div class="control">
      <img
        class="icon"
        src="./img/1.png"
        alt=""
        v-if="!isplaying"
        @click="play"
      />
      <img class="icon" src="./img/2.png" alt="" v-else @click="stopPlay" />
    </div>

    <div class="progress-group">
      <van-slider v-model="currentTime" :min="0" :max="maxTime||record.duration" :setp="0.1" v-show="record.url" @input="changeCurrent"/>
      <div class="progress-bar" v-show="!record.url"></div>
      <div class="progress-play" v-show="!record.url" :style="{ width: percent }"></div>
      <!-- <div class="progress-ball" :style="{'left': percent}"></div> -->
    </div>

    <div class="time-tip">{{ playTime }}</div>
  </div>
</template>

<script>
/**
 * 接收的语音对象示例(如下两种都可以)
 * 1. 本地录制的语音
 * {
 *     localId: "",
 *     duration: 10
 * }
 *
 * 2.
 * {
 *     name: 名字
 *     size: 大小, 单位byte
 *     md5: md5
 *     url: url
 *     extension: 扩展名
 *     duration: 长度, 单位ms
 * }
 *
 */

export default {
  name: "multimedia-record",
  props: {
    value: String,
    record: {
      type: Object,
      default: function () {
        return {};
      },
    },
  },
  data() {
    return {
      // 是否正在播放
      isplaying: false,
      // 倒计时
      lastTime: this.record.duration,
      currentTime:0,
      maxTime:0,
    };
  },
  computed: {
    playTime() {
      // 先将豪秒数转换成秒数
      // let second = this.lastTime / 1000,
      let second = this.record.duration,
        dur = Math.ceil(second),
        s = dur % 60,
        m = Math.floor((dur % 3600) / 60),
        h = Math.floor(dur / 3600);

      s < 10 && (s = `0${s}`);
      m < 10 && (m = `0${m}`);
      h < 10 && (h = `0${h}`);

      if (dur < 3600) {
        return `${m}:${s}`;
      } else {
        return `${h}:${m}:${s}`;
      }
    },
    // 当前播放进度的百分比
    percent() {
      // this.currentTime=+`${(1 - this.lastTime / this.record.duration) * 100}`
      return `${(1 - this.lastTime / this.record.duration) * 100}%`;
    },
  },
  methods: {
    _ontimeupdate(v){
      this.currentTime=v.ag;
      let _this=this;
      setTimeout(() => {
        _this.currentTime=((_this.currentTime===_this.maxTime))?0:_this.currentTime
      }, 100);
      // console.log('设置时间',v)
    },
    _onloadedmetadata(v){
      this.maxTime=v.ag
      // console.log(v,'加载秒数');
    },
    changeCurrent(v){
      // console.log(v,'设置事件')
      if(this.record.url){
        app.module.voice.setCurrentTime(v);
      }
    },
    // 语音加载中....
    _onloading() {
      this.isplaying = false;
    },
    // 语音开始播放....
    _onplaying() {
      this.isplaying = true;

      let interval = 40;

      // 定时器的指向
      this.timer = setInterval(() => {
        // this.lastTime -= interval;
        this.lastTime = this.lastTime - interval/1000
        
        if (this.lastTime <= 0) {
          this.lastTime = 0;
          clearInterval(this.timer);
        }
      }, interval);
    },
    // 回到默认状态...
    _ondefault() {
      clearInterval(this.timer);
      this.lastTime = this.record.duration;
      this.isplaying = false;
    },
    play() {
      // console.log(this.record.url)
      if (!this.record.url && app.base.env == "browser" && this.record.env == "wx") {
        vant.Toast({
          icon: "fail",
          message: "暂不支持播放该语音",
        });
      } else {
        let opt = {
          loading: this._onloading,
          playing: this._onplaying,
          end: this._ondefault,
          endAuto: this._ondefault,
          error: this._ondefault,
        };
        if(this.record.url){
          opt.timeupdate=this._ontimeupdate;
          opt.loadedmetadata=this._onloadedmetadata;
          this.currentTime=(this.currentTime===this.maxTime)?0:this.currentTime
        }
        app.module.voice.play(this.record, opt,this.currentTime);
      }
    },
    stopPlay() {
      app.module.voice.stop();
    },
  },
  // 实例销毁之前调用, 离开前停止正在播放的语音
  beforeDestroy() {
    // 有可能有语音正在播放中，先停止掉.
    app.module.voice.stop();
  },
};
</script>

<style lang="scss" scoped>
.multimedia-record {
  height: 50px;
  line-height: 50px;
  background-color: #fafafa;
  border-radius: 5px;
  border: 1px solid #eee;
  display: flex;
  align-items: center;
  .control {
    padding-left: 10px;
    padding-right: 20px;
    .icon {
      // font-size: 30px;
      width: 30px;
      vertical-align: middle;
    }
  }
  .progress-group {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    /deep/ .van-slider__bar{
      transition:all 0.5s;
    }
    .progress-bar {
      position: absolute;
      height: 2px;
      background-color: #ddd;
      width: 100%;
    }
    .progress-play {
      position: absolute;
      height: 2px;
      width: 0;
      background-color: #1e88f5;
    }
    .progress-ball {
      position: absolute;
      left: 0;
      width: 10px;
      height: 10px;
      margin-left: -5px;
      background-color: #1e88f5;
      border-radius: 10px;
    }
  }
  .time-tip {
    padding-left: 20px;
    padding-right: 14px;
  }
}
</style>
